import React from 'react';

export const Themes: React.FC = () => {
  return <div>Themes</div>;
};
